import { Injectable } from '@angular/core';
import { IndustrieReport, ReportAnfrage } from 'src/app/shared/model';
import { Observable } from 'rxjs';

@Injectable()
export abstract class ReportingService {
    abstract reportGenerieren(
        anfrage: ReportAnfrage
    ): Observable<IndustrieReport>;

    abstract kummulativReportGenerieren(
        anfrage: any
    ): Observable<any>;
}
